import React from "react";
import { useSearchParams } from "react-router-dom";
import IntegrationSearch from "./IntegrationSearch";
import IntegrationTable from "./IntegrationTable";

const Integration = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  // 1) 기본 URL ↔ form defaultValues 동기화
  const defaultValues = {
    eduCategoryId: searchParams.get("eduCategoryId") || "",
    eduType:       searchParams.get("eduType")       || "",
    srcStartDate:  searchParams.get("srcStartDate")  || "",
    srcEndDate:    searchParams.get("srcEndDate")    || "",
    searchCnd:     searchParams.get("searchCnd")     || "",
    searchWrd:     searchParams.get("searchWrd")     || "",
  };

  // 2) 검색(submit) 시 URL 재설정
  const handleSearch = (data) => {
    const params = new URLSearchParams();
    params.set("pageIndex", "1");
    if (data.eduCategoryId) params.set("eduCategoryId", data.eduCategoryId);
    if (data.eduType)       params.set("eduType", data.eduType);
    if (data.srcStartDate)  params.set("srcStartDate", data.srcStartDate);
    if (data.srcEndDate)    params.set("srcEndDate", data.srcEndDate);
    if (data.searchCnd)     params.set("searchCnd", data.searchCnd);
    if (data.searchWrd)     params.set("searchWrd", data.searchWrd);
    setSearchParams(params);
  };

  return (
    <div className="contents-wrap">
      <div className="page-title-wrap">
        <h2><span className="icon-dot-circle" /> 통합수강생정보 관리</h2>
      </div>
      <div className="tab-cont-wrap">
      <div className="tab-cont-01 on">
          <IntegrationSearch defaultValues={defaultValues} onSearch={handleSearch} />
          <section className="section-wrap">
            <IntegrationTable
              searchParams={searchParams}
              setSearchParams={setSearchParams}
            />
          </section>
        </div>
      </div>
    </div>
  );
};

export { Integration };
